// src/utils/cache.js
import LRU from 'lru-cache';

const options = {
  max: 100, 
  maxAge: 1000 * 60 * 60 * 2
};

const cache = new LRU(options);

export default cache;
